import { jsx as _jsx } from "react/jsx-runtime";
import { ApplicationSizeContext } from './context/ApplicationSize';
import { useViewportSize } from './hooks/useViewportSize';
const ApplicationSizeProvider = ({ className, children, renderingMode = 'csr', }) => {
    const size = useViewportSize({ renderingMode });
    return (_jsx(ApplicationSizeContext.Provider, { value: size, children: _jsx("div", { className: className, children: children }) }));
};
export default ApplicationSizeProvider;
